import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function FadeInSection({ children }) {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.4, 0.8, 1], [0, 1, 1, 0]);
  const scale = useTransform(
    scrollYProgress,
    [0, 0.4, 0.8, 1],
    [0.9, 1, 1, 0.9]
  );
  const y = useTransform(scrollYProgress, [0, 0.4, 0.8, 1], [20, 0, 0, -20]);
  const blur = useTransform(scrollYProgress, [0, 0.4, 0.8, 1], [3, 0, 0, 3]);

  return (
    <motion.div
      ref={ref}
      style={{
        opacity,
        scale,
        y,
        filter: useTransform(blur, (b) => `blur(${b}px)`),
        willChange: "opacity, transform, filter",
      }}>
      {children}
    </motion.div>
  );
}
